<template>
    <b-button
        variant="primary"
        v-if="$temAcessoView('CTRLACS-USR-05')"
        @click.stop="confirmarAtivarDesativarUsuario()"
        class="mr-2"
        >{{ operacaoBtn }} Usuário</b-button
    >
</template>

<script>
import UsuariosServicos from './UsuariosServicos'

export default {
    props: {
        usuario: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            operacaoTitulo: '',
            operacaoTexto: '',
            operacaoBtn: ''
        }
    },

    methods: {
        confirmarAtivarDesativarUsuario() {
            this.$swal({
                title: `${this.operacaoTitulo} de Usuário`,
                html: `Confirma a ${this.operacaoTexto} do usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.ativarDesativarUsuario()
                }
            })
        },

        ativarDesativarUsuario() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.ativarDesativarUsuario(
                this.$route.params.usuarioId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$store.dispatch('setRecarregar', true)
                        this.$emit('obterUsuario')
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    watch: {
        usuario() {
            if (this.usuario.status === 1 || this.usuario.status === 2) {
                this.operacaoTitulo = 'Desativação'
                this.operacaoTexto = 'desativação'
                this.operacaoBtn = 'Desativar'
            } else {
                this.operacaoTitulo = 'Ativação'
                this.operacaoTexto = 'ativação'
                this.operacaoBtn = 'Ativar'
            }
        }
    }
}
</script>
